/* Atelier Lazuli — theme.js
   Vanilla, sans dépendance. Chaque module est indépendant et ne s'exécute que si son
   balisage est présent. */
(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const money = (cents) => fmt.format(cents / 100).replace(/ /g, ' ');
  const lock = (on) => document.body.classList.toggle('is-locked', on);
  /* Compteur anonyme (Umami, sans cookies) : ne fait rien tant qu'il n'est pas branché. */
  const suivi = (nom, donnees) => { try { if (window.umami && typeof window.umami.track === 'function') window.umami.track(nom, donnees); } catch (e) { /* jamais bloquant */ } };

  /* ---------- Toast ---------- */
  let toastEl, toastTimer;
  const toast = (msg) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };

  /* ---------- En-tête : état au défilement ---------- */
  const header = $('.header');
  if (header) {
    let last = -1;
    const onScroll = () => {
      const y = window.scrollY;
      const scrolled = y > 24;
      if (scrolled !== (last > 24)) header.classList.toggle('is-scrolled', scrolled);
      last = y;
    };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Menu déroulant (couleurs) ---------- */
  $$('[data-menu]').forEach((item) => {
    const btn = $('[data-menu-toggle]', item);
    const panel = $('.menu', item);
    if (!btn || !panel) return;
    let t;
    const open = () => { clearTimeout(t); panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = () => { panel.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', () => (panel.classList.contains('is-open') ? close() : open()));
    item.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) open(); });
    item.addEventListener('mouseleave', () => { if (matchMedia('(hover:hover)').matches) t = setTimeout(close, 160); });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    document.addEventListener('click', (e) => { if (!item.contains(e.target)) close(); });
  });

  /* ---------- Menu mobile ---------- */
  const drawerNav = $('[data-drawer-nav]');
  if (drawerNav) {
    const openNav = () => { drawerNav.classList.add('is-open'); drawerNav.setAttribute('aria-hidden', 'false'); lock(true); $('[data-nav-close]', drawerNav)?.focus(); };
    const closeNav = () => { drawerNav.classList.remove('is-open'); drawerNav.setAttribute('aria-hidden', 'true'); lock(false); };
    $$('[data-nav-open]').forEach((b) => b.addEventListener('click', openNav));
    $$('[data-nav-close]', drawerNav).forEach((b) => b.addEventListener('click', closeNav));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawerNav.classList.contains('is-open')) closeNav(); });
  }

  /* ---------- Recherche ---------- */
  const searchBar = $('[data-search-bar]');
  if (searchBar) {
    const toggle = (force) => {
      const on = force ?? !searchBar.classList.contains('is-open');
      searchBar.classList.toggle('is-open', on);
      $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(on)));
      if (on) setTimeout(() => $('input', searchBar)?.focus(), 60);
    };
    $$('[data-search-toggle]').forEach((b) => b.addEventListener('click', () => toggle()));
    $('[data-search-close]', searchBar)?.addEventListener('click', () => toggle(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') toggle(false); });
  }

  /* ---------- Révélations ---------- */
  const revealEls = $$('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window && !reduceMotion) {
    $$('[data-reveal-group]').forEach((g) => {
      $$('[data-reveal]', g).forEach((el, i) => { el.style.setProperty('--d', `${Math.min(i, 9) * 70}ms`); });
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    const fold = innerHeight * 0.92;
    revealEls.forEach((el) => {
      if (el.getBoundingClientRect().top < fold) return;   /* visible d'emblee : aucun fondu */
      el.classList.add('will-reveal');
      io.observe(el);
    });
  }

  /* ---------- Parallaxe ---------- */
  const pxEls = $$('[data-parallax]');
  if (pxEls.length && !reduceMotion && matchMedia('(min-width: 900px)').matches && matchMedia('(hover: hover)').matches) {
    let ticking = false;
    const update = () => {
      const vh = innerHeight;
      pxEls.forEach((el) => {
        const host = el.parentElement;
        const r = host.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const speed = parseFloat(el.dataset.parallax) || 0.18;
        const center = r.top + r.height / 2 - vh / 2;
        el.style.transform = `translate3d(0, ${(-center * speed).toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', req, { passive: true });
    addEventListener('resize', req);
    update();
  }

  /* ---------- Dates de livraison ---------- */
  const dateFmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
  const dateCourt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
  const etroit = window.matchMedia('(max-width: 700px)');
  /* 02/10 : le délai annoncé est en jours ouvrés (lundi à vendredi, hors jours fériés français). */
  const feriesAn = {};
  const feries = (an) => {
    if (feriesAn[an]) return feriesAn[an];
    const a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      paques = new Date(an, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
    const apresPaques = (n) => { const x = new Date(paques); x.setDate(x.getDate() + n); return `${x.getMonth() + 1}-${x.getDate()}`; };
    /* jour de l'an, 1er et 8 mai, 14 juillet, 15 août, Toussaint, 11 novembre, Noël, lundi de Pâques, Ascension, lundi de Pentecôte */
    return (feriesAn[an] = new Set(['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25', apresPaques(1), apresPaques(39), apresPaques(50)]));
  };
  const jourOuvre = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !feries(d.getFullYear()).has(`${d.getMonth() + 1}-${d.getDate()}`);
  const dansJoursOuvres = (n) => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (jourOuvre(d)) n--; } return d; };
  const ecrireDates = () => $$('[data-delivery-dates]').forEach((el) => {
    const min = parseInt(el.dataset.min || '8', 10), max = parseInt(el.dataset.max || '17', 10);
    const a = dansJoursOuvres(min), b = dansJoursOuvres(max);
    el.textContent = el.dataset.fmt === 'court'
      ? (a.getMonth() === b.getMonth() ? `${a.getDate()}\u2013${dateCourt.format(b)}` : `${dateCourt.format(a)} \u2013 ${dateCourt.format(b)}`)
      : etroit.matches
      ? `\u00b7 ${dateCourt.format(a)} \u2013 ${dateCourt.format(b)}`
      : `entre le ${dateFmt.format(a)} et le ${dateFmt.format(b)}`;
  });
  ecrireDates();
  etroit.addEventListener?.('change', ecrireDates);

  /* ---------- Panier ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  /* 30/09 : mesures dans le panier, rien de visible : durée d'ouverture et façon de le fermer,
     défilement, bouton « Passer commande » réellement vu. */
  const panierSuivi = (() => {
    let debut = 0, vus = new Set(), boutonVu = false, io = null;
    const articles = () => $$('[data-line]', cartDrawer).filter((l) => !l.matches('[data-gift-line]')).length;
    const observeBouton = () => {
      if (!cartDrawer || boutonVu || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      const b = $('button[name="checkout"]', cartDrawer);
      if (!b) return;
      io = new IntersectionObserver(([e]) => { if (e.isIntersecting && !boutonVu) { boutonVu = true; suivi('vu', { zone: 'bouton-commande' }); io.disconnect(); } }, { threshold: .6 });
      io.observe(b);
    };
    return {
      debut() { if (debut && cartDrawer.classList.contains('is-open')) return; debut = Date.now(); vus = new Set(); boutonVu = false; setTimeout(observeBouton, 450); },
      rendu() { if (debut) observeBouton(); },
      fin(via) {
        if (!debut) return;
        suivi('panier-ferme', { via, secondes: Math.round((Date.now() - debut) / 1000), articles: articles() });
        debut = 0; if (io) io.disconnect();
      },
      defile(el) {
        if (!debut || !el || !el.scrollHeight) return;
        const max = el.scrollHeight - el.clientHeight;
        if (max < 40) return;
        const pct = Math.round(100 * el.scrollTop / max);
        [25, 50, 75, 100].forEach((p) => { if (pct >= p - 2 && !vus.has(p)) { vus.add(p); suivi('panier-defile', { pct: p }); } });
      }
    };
  })();
  const suiviRetrait = (line) => {
    if (!line) return;
    const titre = ($('.line__title', line)?.textContent || '').trim();
    suivi('panier-retire', { cadeau: line.matches('[data-gift-line]') ? 'oui' : 'non', motif: titre.replace(/^.*?vintage\s+/i, '').toLowerCase().slice(0, 40), taille: ($('.line__variant', line)?.textContent || '').trim().slice(0, 20) });
  };
  const cart = {
    open() { if (!cartDrawer) return; suivi('panier-ouvert'); panierSuivi.debut(); cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false'); lock(true); setTimeout(() => $('[data-cart-close]', cartDrawer)?.focus(), 80); },
    close(via) { if (!cartDrawer) return; panierSuivi.fin(via || 'autre'); cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden', 'true'); lock(false); },
    render(sections) {
      const html = sections && sections['cart-drawer'];
      if (!html || !cartDrawer) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-drawer-inner]', doc);
      const cur = $('[data-cart-drawer-inner]', cartDrawer);
      if (fresh && cur) cur.replaceWith(fresh);
      const count = $('[data-cart-count-src]', cartDrawer)?.dataset.cartCountSrc;
      if (count !== undefined) cart.setCount(count);
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      panierSuivi.rendu();
      boutonMotifs();
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.dataset.count = n; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
    },
    async request(url, body) {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: 'cart-drawer' }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Erreur panier');
      return data;
    },
    async add(items) {
      const data = await cart.request('/cart/add.js', { items });
      cart.render(data.sections);
      return data;
    },
    async change(line, quantity) {
      const data = await cart.request('/cart/change.js', { line, quantity });
      cart.render(data.sections);
      return data;
    }
  };
  /* Tapis d'entree offert des 100 EUR. Il prend le motif du dernier tapis
     ajoute ; un motif choisi a la main tient jusqu'au prochain ajout. */
  const GIFT_HANDLE = 'tapis-dentree-persan-vintage';
  const giftMap = () => { try { return JSON.parse($('[data-gift-map]')?.textContent || '{}'); } catch (e) { return {}; } };
  const giftFam = () => {
    const el = $('[data-gift-fam]');
    try { return { fam: JSON.parse(el?.textContent || '{}'), min2: (el?.dataset.min2 || '').split(',').filter(Boolean) }; } catch (e) { return { fam: {}, min2: [] }; }
  };
  const colourOf = (item) => (item.product_title || '').replace(/^.*?vintage\s+/i, '').trim().toLowerCase();
  const CHOIX = 'al-cadeau-choisi';
  const choixLu = (token) => { try { const c = JSON.parse(localStorage.getItem(CHOIX) || 'null'); return c && c.token === token ? String(c.id) : null; } catch (e) { return null; } };
  const choixNote = (token, id) => { try { if (id) localStorage.setItem(CHOIX, JSON.stringify({ token, id: String(id) })); else localStorage.removeItem(CHOIX); } catch (e) { /* sans stockage, le cadeau suit le tapis */ } };
  /* Motif que le client vient de choisir (liste ou fenetre) : majCadeau le note puis le controle. */
  let choixEnAttente = null;
  /* Vrai quand le dernier passage de majCadeau a modifie le panier. */
  let cadeauChange = false;
  const rafraichirTiroir = async () => {
    const r = await fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } });
    if (r.ok) cart.render(await r.json());
  };
  const majCadeau = async (ajout) => {
    const attendu = choixEnAttente;
    choixEnAttente = null;
    cadeauChange = false;
    const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    const rugs = c.items.filter((i) => i.handle !== GIFT_HANDLE);
    const gifts = c.items.filter((i) => i.handle === GIFT_HANDLE);
    const rugTotal = rugs.reduce((s, i) => s + i.final_line_price, 0);
    if (ajout && ajout.length) choixNote(c.token, null);
    if (!rugs.length || rugTotal < 10000) {
      if (gifts.length) { const d = await cart.request('/cart/update.js', { updates: Object.fromEntries(gifts.map((g) => [g.key, 0])) }); cart.render(d.sections); cadeauChange = true; }
      return null;
    }
    const map = giftMap();
    const ids = Object.values(map).map(String);
    const dernier = (ajout && rugs.find((i) => ajout.includes(i.variant_id))) || rugs[0];
    /* 03/10 : le tapis d'entree se choisit parmi les motifs du meme fabricant que le tapis achete
       (cle « famille »). Un fabricant qui ne vend pas une piece seule et n'a qu'un tapis dans le
       panier passe d'abord : le cadeau l'accompagne. Sinon, tout motif d'un fabricant present dans
       le panier convient. Sans famille connue : comme avant, tous les motifs. */
    const { fam, min2 } = giftFam();
    const famDe = (rug) => fam[String(map[colourOf(rug)])] || '';
    const pieces = {};
    rugs.forEach((r) => { const f = famDe(r); pieces[f] = (pieces[f] || 0) + r.quantity; });
    const seuls = rugs.filter((r) => min2.includes(famDe(r)) && pieces[famDe(r)] === 1);
    const ref = seuls[0] || dernier;
    const fams = (seuls.length ? seuls : rugs).map(famDe);
    const permis = fams.every(Boolean) ? ids.filter((id) => fams.includes(fam[id])) : ids;
    if (attendu) choixNote(c.token, attendu);
    const choisi = choixLu(c.token);
    const cible = (choisi && permis.includes(choisi) ? choisi : '') || String(map[colourOf(ref)] || permis[0] || '');
    if (!cible) return null;
    const garde = gifts.find((g) => String(g.variant_id) === cible);
    const updates = Object.fromEntries(gifts.filter((g) => g !== garde).map((g) => [g.key, 0]));
    if (garde && garde.quantity !== 1) updates[garde.key] = 1;
    let d = null;
    /* le nouveau d'abord, le retrait ensuite : si l'ajout echoue, l'ancien tapis d'entree reste */
    if (!garde) d = await cart.request('/cart/add.js', { items: [{ id: parseInt(cible, 10), quantity: 1 }] });
    if (Object.keys(updates).length) d = await cart.request('/cart/update.js', { updates });
    if (d) { cart.render(d.sections); cadeauChange = true; }
    else if (attendu) await rafraichirTiroir(); /* choix refuse ou deja en place : la liste revient a l'etat reel */
    return garde ? null : cible;
  };
  /* Une mise a jour a la fois : deux ajouts rapproches passent l'un apres l'autre. */
  let fileCadeau = Promise.resolve(null);
  cart.ensureGift = (ajout) => {
    const p = fileCadeau.then(() => majCadeau(ajout)).catch(() => null); /* silencieux : le panier reste utilisable */
    fileCadeau = p;
    return p;
  };
  /* Changement de motif par le client : on note son choix, majCadeau l'applique s'il vient du bon fabricant.
     On ne se fie plus au numero de ligne de la page (il peut dater : retour arriere, autre onglet). */
  const choisirCadeau = (id) => { choixEnAttente = String(id); return cart.ensureGift(); };

  /* Fenetre du cadeau : elle explique l'offre et laisse changer de motif */
  const giftModal = $('[data-gift-modal]');
  const giftShow = (id) => {
    if (!giftModal) return false;
    /* seuls les motifs de la meme famille que le tapis d'entree pose sont proposes */
    const { fam } = giftFam();
    const f = fam[String(id)];
    $$('[data-gift-pick]', giftModal).forEach((i) => { const l = i.closest('label'); if (l) l.hidden = !!f && fam[i.value] !== f; });
    const pick = $(`[data-gift-pick][value="${id}"]`, giftModal) || $('[data-gift-pick]', giftModal);
    if (pick) { pick.checked = true; giftSync(pick); }
    giftModal.hidden = false;
    void giftModal.offsetWidth;
    giftModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    $('[data-gift-confirm]', giftModal)?.focus({ preventScroll: true });
    return true;
  };
  const giftHide = () => {
    if (!giftModal) return;
    giftModal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { giftModal.hidden = true; }, 420);
  };
  function giftSync(pick) {
    $$('[data-gift-shot]', giftModal).forEach((f) => f.classList.toggle('is-on', f.dataset.giftShot === pick.value));
    const name = $('[data-gift-name]', giftModal);
    if (name) name.textContent = pick.dataset.name || '';
  }
  const giftSwap = async (id) => {
    giftModal.classList.add('is-busy');
    try { await choisirCadeau(id); }
    finally { giftModal.classList.remove('is-busy'); }
  };
  if (giftModal) {
    giftModal.addEventListener('click', (e) => {
      if (e.target.closest('[data-gift-close]')) { giftHide(); return; }
      if (e.target.closest('[data-gift-confirm]')) { giftHide(); setTimeout(() => cart.open(), 180); }
    });
    giftModal.addEventListener('change', (e) => {
      const pick = e.target.closest('[data-gift-pick]');
      if (!pick) return;
      suivi('cadeau-change', { motif: (pick.dataset.name || '').toLowerCase(), via: 'fenetre' });
      giftSync(pick);
      giftSwap(pick.value);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && giftModal.classList.contains('is-open')) giftHide(); });
    document.addEventListener('click', (e) => { const b = e.target.closest('[data-gift-open]'); if (!b) return; e.preventDefault(); suivi('cadeau-ouvre'); giftShow(b.dataset.giftCurrent); });
  }

  const _add = cart.add, _change = cart.change;
  cart.giftPending = false;
  cart.add = async (items) => {
    const d = await _add(items);
    (d.items || []).filter((i) => i.handle !== GIFT_HANDLE).forEach((i) => suivi('ajout-panier', { taille: i.variant_title, motif: colourOf(i), prix: Math.round(i.final_price / 100) }));
    const pose = await cart.ensureGift(items.map((i) => Number(i.id)));
    /* 29/09 : plus de fenêtre plein écran juste après l'ajout (elle cachait le chemin vers le paiement) :
       le panier s'ouvre directement, le tapis d'entrée assorti y est déjà, « Voir les motifs » rouvre le choix. */
    cart.giftPending = false; void pose;
    return d;
  };
  cart.change = async (line, quantity) => { const d = await _change(line, quantity); await cart.ensureGift(); return d; };
  document.addEventListener('change', async (e) => {
    const sel = e.target.closest('[data-gift-motif]');
    if (!sel) return;
    suivi('cadeau-change', { motif: (sel.options[sel.selectedIndex]?.text || '').toLowerCase(), via: 'liste' });
    const lineEl = sel.closest('[data-line]');
    lineEl.style.opacity = '.5';
    await choisirCadeau(sel.value);
    if ($('[data-cart-page]')) location.reload();
    else if (lineEl.isConnected) lineEl.style.opacity = '';
  });

  /* Au chargement d'une page et au retour arriere du navigateur, le panier affiche peut dater
     (panier d'avant le 03/10, autre onglet). S'il porte un tapis d'entree, on relit le vrai panier et on
     remet le tapis d'entree chez le bon fabricant. Une seule lecture ; aucune ecriture si tout est bon. */
  const RECHARGE = 'al-cadeau-recharge';
  const verifieCadeau = async (retour) => {
    if (retour && $('[data-cart-page]')) { location.reload(); return; }
    if (retour) await rafraichirTiroir().catch(() => {});
    if (!$('[data-gift-line]')) return;
    await cart.ensureGift();
    if (!$('[data-cart-page]')) return;
    try {
      if (!cadeauChange) { sessionStorage.removeItem(RECHARGE); return; }
      if (sessionStorage.getItem(RECHARGE)) return; /* jamais deux rechargements de suite */
      sessionStorage.setItem(RECHARGE, '1');
    } catch (e) { return; }
    location.reload();
  };
  verifieCadeau(false);
  window.addEventListener('pageshow', (e) => { if (e.persisted) verifieCadeau(true); });
  /* La fenetre des motifs n'existe que sur les fiches produit : ailleurs, son bouton ne ferait rien. */
  const boutonMotifs = () => { if (!giftModal) $$('[data-gift-open]').forEach((b) => { b.hidden = true; }); };
  boutonMotifs();

  /* Comportement sur la fiche produit (compteur anonyme) : jusqu'où on descend,
     ce qu'on ouvre, combien de temps on reste vraiment. */
  if ($('[data-product]')) {
    const vus = new Set();
    const paliers = () => {
      const h = document.documentElement.scrollHeight - innerHeight;
      if (h <= 0) return;
      const pct = (scrollY / h) * 100;
      [25, 50, 75, 100].forEach((p) => { if (pct >= p - 2 && !vus.has(p)) { vus.add(p); suivi('profondeur', { pct: p }); } });
    };
    addEventListener('scroll', paliers, { passive: true });
    const reperes = [['prix', '[data-price-box]'],['bouton-panier', '[data-product] form button[type="submit"]'], ['guide-tailles', '.sizes, [data-size-guide]'], ['autres-tapis', '.pgrid'], ['autres-couleurs', '[data-pmore]']];
    if ('IntersectionObserver' in window) {
      reperes.forEach(([nom, sel]) => {
        const el = $(sel);
        if (!el) return;
        const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { suivi('vu', { zone: nom }); io.disconnect(); } }, { threshold: .5 });
        io.observe(el);
      });
    }
    $$('[data-pmore-item]').forEach((a) => a.addEventListener('click', () => suivi('clic-autres-couleurs', { motif: a.dataset.pmoreItem })));
    $$('[data-product] details, .pdetail details').forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) suivi('ouvre', { rubrique: ($('summary', d)?.textContent || '').trim().slice(0, 40) });
    }));
    let actif = 0;
    const temps = [10, 30, 60, 120];
    setInterval(() => {
      if (document.hidden) return;
      actif += 5;
      if (temps.includes(actif)) suivi('temps-fiche', { secondes: actif });
    }, 5000);
  }

  /* Passage au paiement (classique ou paiement express) et choix de taille */
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('button[name="checkout"], [data-checkout], a[href$="/checkout"]')) suivi('paiement-clic', { mode: 'classique' });
    else if (t.closest('.express, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) suivi('paiement-clic', { mode: 'express' });
  }, true);
  document.addEventListener('change', (e) => {
    const r = e.target.closest('[data-product] input[type="radio"][name^="options"]');
    if (r) suivi('choix-taille', { taille: r.value });
  });

  /* Recherche dans la FAQ : sans accent, mot a mot, avec surlignage. */
  const faqRoot = $('[data-faq]');
  if (faqRoot) {
    const champ = $('[data-faq-input]', faqRoot);
    const vider = $('[data-faq-clear]', faqRoot);
    const compte = $('[data-faq-count]', faqRoot);
    const vide = $('[data-faq-empty]', faqRoot);
    const nav = $('.faqpage__nav', faqRoot);
    const items = $$('.faq details', faqRoot).map((d) => {
      const q = $('summary', d), r = $('.faq__body p', d);
      return { d, q, r, qHtml: q.innerHTML, rHtml: r ? r.innerHTML : '', txt: pl(q.textContent + ' ' + (r ? r.textContent : '')) };
    });
    const blocs = $$('.faqpage__bloc', faqRoot);
    function pl(s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
    function surligne(html, mots) {
      if (!mots.length) return html;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const marche = (n) => {
        if (n.nodeType === 3) {
          const src = n.nodeValue, plat = pl(src);
          const zones = [];
          mots.forEach((m) => { let i = plat.indexOf(m); while (i !== -1) { zones.push([i, i + m.length]); i = plat.indexOf(m, i + m.length); } });
          if (!zones.length) return;
          zones.sort((a, b) => a[0] - b[0]);
          const frag = document.createDocumentFragment();
          let pos = 0;
          zones.forEach(([a, b]) => {
            if (a < pos) return;
            frag.appendChild(document.createTextNode(src.slice(pos, a)));
            const mk = document.createElement('mark'); mk.textContent = src.slice(a, b);
            frag.appendChild(mk); pos = b;
          });
          frag.appendChild(document.createTextNode(src.slice(pos)));
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'MARK') {
          [...n.childNodes].forEach(marche);
        }
      };
      [...tmp.childNodes].forEach(marche);
      return tmp.innerHTML;
    }
    const filtre = () => {
      const brut = champ.value.trim();
      const mots = pl(brut).split(/[^a-z0-9]+/).filter((m) => m.length > 1);
      vider.hidden = !brut;
      if (nav) nav.hidden = !!brut;
      let n = 0;
      items.forEach((it) => {
        const ok = !mots.length || mots.every((m) => it.txt.includes(m));
        it.d.hidden = !ok;
        if (ok) n++;
        it.d.open = !!mots.length && ok;
        it.q.innerHTML = mots.length && ok ? surligne(it.qHtml, mots) : it.qHtml;
        const r = $('.faq__body p', it.d);
        if (r) r.innerHTML = mots.length && ok ? surligne(it.rHtml, mots) : it.rHtml;
      });
      blocs.forEach((b) => { b.hidden = !$$('.faq details:not([hidden])', b).length; });
      if (!brut) { compte.hidden = true; vide.hidden = true; return; }
      vide.hidden = n > 0;
      compte.hidden = n === 0;
      compte.textContent = n + (n > 1 ? ' questions trouvees' : ' question trouvee');
      compte.textContent = n + (n > 1 ? ' questions trouvées' : ' question trouvée');
    };
    let t = null;
    champ.addEventListener('input', () => { clearTimeout(t); t = setTimeout(filtre, 110); });
    vider.addEventListener('click', () => { champ.value = ''; champ.focus(); filtre(); });
    const q0 = new URLSearchParams(location.search).get('q');
    if (q0) { champ.value = q0; filtre(); }
  }

  window.theme = Object.assign(window.theme || {}, { cart, toast, money });

  if (cartDrawer) {
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); cart.open(); }));
    cartDrawer.addEventListener('click', (e) => {
      if (e.target.closest('button[name="checkout"]')) panierSuivi.fin('commande');
      else if (e.target.closest('.express, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) panierSuivi.fin('express');
      if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-scrim]')) { cart.close(e.target.matches('[data-cart-scrim]') ? 'fond' : 'bouton'); return; }
      const qbtn = e.target.closest('[data-qty-change]');
      if (qbtn) {
        const line = qbtn.closest('[data-line]');
        const input = $('input', line.querySelector('.qty'));
        const q = Math.max(0, parseInt(input.value, 10) + parseInt(qbtn.dataset.qtyChange, 10));
        if (q === 0) suiviRetrait(line); else suivi('panier-quantite', { quantite: q });
        line.style.opacity = '.5';
        cart.change(parseInt(line.dataset.line, 10), q).catch((err) => { toast(err.message); line.style.opacity = ''; });
        return;
      }
      const rm = e.target.closest('[data-line-remove]');
      if (rm) {
        const line = rm.closest('[data-line]');
        suiviRetrait(line);
        line.style.opacity = '.5';
        cart.change(parseInt(line.dataset.line, 10), 0).catch((err) => { toast(err.message); line.style.opacity = ''; });
      }
    });
    cartDrawer.addEventListener('scroll', (e) => panierSuivi.defile(e.target), true);
    window.addEventListener('pagehide', () => { if (cartDrawer.classList.contains('is-open')) panierSuivi.fin('depart'); });
    cartDrawer.addEventListener('change', (e) => {
      const input = e.target.closest('.qty input');
      if (!input) return;
      const line = input.closest('[data-line]');
      cart.change(parseInt(line.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0)).catch((err) => toast(err.message));
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) cart.close('echap'); });
  }

  /* Page panier : quantités et suppression sans rechargement complet */
  const cartPage = $('[data-cart-page]');
  if (cartPage) {
    cartPage.addEventListener('click', async (e) => {
      const qbtn = e.target.closest('[data-qty-change]');
      const rm = e.target.closest('[data-line-remove]');
      if (!qbtn && !rm) return;
      e.preventDefault();
      const line = (qbtn || rm).closest('[data-line]');
      let q = 0;
      if (qbtn) { const input = $('input', line.querySelector('.qty')); q = Math.max(0, parseInt(input.value, 10) + parseInt(qbtn.dataset.qtyChange, 10)); }
      if (q === 0) suiviRetrait(line); else suivi('panier-quantite', { quantite: q });
      line.style.opacity = '.5';
      try { await cart.change(parseInt(line.dataset.line, 10), q); location.reload(); } catch (err) { toast(err.message); line.style.opacity = ''; }
    });
  }

  /* ---------- Plan de salon : pose du tapis (paysage par défaut, rotation possible) ---------- */
  const placeRug = (scene, w, h, portrait) => {
    if (!scene || !w || !h) return;
    const W = 560, sofaBottom = 138;
    const rw = portrait ? w : h, rh = portrait ? h : w;
    const overlap = rh >= 300 ? 60 : rh >= 230 ? 40 : rh >= 200 ? 30 : rh >= 180 ? 14 : rh >= 160 ? 12 : rh >= 140 ? 4 : 0;
    let y = sofaBottom - overlap;
    if (y + rh < 282) y = 282 - rh;
    const x = Math.round((W - rw) / 2);
    $$('[data-scene-rug]', scene).forEach((r) => { r.setAttribute('x', x); r.setAttribute('y', y); r.setAttribute('width', rw); r.setAttribute('height', rh); });
    const img = $('[data-scene-img]', scene);
    if (img) {
      const cx = x + rw / 2, cy = y + rh / 2;
      if (portrait) {
        img.setAttribute('x', (x - rw * 0.09).toFixed(1)); img.setAttribute('y', (y - rh * 0.07).toFixed(1));
        img.setAttribute('width', (rw * 1.18).toFixed(1)); img.setAttribute('height', (rh * 1.14).toFixed(1));
        img.removeAttribute('transform');
      } else {
        const a = rh * 1.18, b = rw * 1.14;
        img.setAttribute('x', (cx - a / 2).toFixed(1)); img.setAttribute('y', (cy - b / 2).toFixed(1));
        img.setAttribute('width', a.toFixed(1)); img.setAttribute('height', b.toFixed(1));
        img.setAttribute('transform', `rotate(90 ${cx} ${cy})`);
      }
    }
    const label = $('[data-scene-dim]', scene);
    if (label) { label.textContent = `${w} × ${h} cm`; label.setAttribute('x', W / 2); label.setAttribute('y', y + rh + 18); }
    scene.dataset.w = w; scene.dataset.h = h; scene.dataset.portrait = String(!!portrait);
  };
  $$('[data-scene-rotate]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const scene = $('[data-scene]', btn.closest('[data-scene-host]') || document);
      if (!scene) return;
      const portrait = scene.dataset.portrait !== 'true';
      placeRug(scene, parseInt(scene.dataset.w, 10), parseInt(scene.dataset.h, 10), portrait);
      btn.setAttribute('aria-pressed', String(portrait));
    });
  });

  /* ---------- Fiche produit ---------- */
  $$('[data-product]').forEach((root) => {
    const form = $('form[data-product-form]', root);
    const variants = JSON.parse($('[data-variants]', root)?.textContent || '[]');
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare-price]', root);
    const idInput = $('input[name="id"]', form);
    const btn = $('[data-add-to-cart]', form);
    const btnText = btn && $('[data-add-text]', btn);
    const useEl = $('[data-size-use]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const stickySize = $('[data-sticky-size]', root);
    const scene = $('[data-scene]', root);

    const findVariant = () => {
      const chosen = $$('input[type="radio"][name^="options"]:checked, select[name^="options"]', form).map((i) => i.value);
      return variants.find((v) => chosen.every((val, i) => v.options[i] === val)) || null;
    };

    const setScene = (w, h) => placeRug(scene, w, h, scene && scene.dataset.portrait === 'true');

    const update = () => {
      const v = findVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      const sale = !!(v.compare_at_price && v.compare_at_price > v.price);
      if (compareEl) { compareEl.hidden = !sale; if (sale) compareEl.textContent = money(v.compare_at_price); }
      $('[data-price-box]', root)?.classList.toggle('is-sale', sale);
      const badge = $('[data-sale-badge]', root);
      if (badge) badge.hidden = !sale;
      if (stickyPrice) { stickyPrice.classList.toggle('is-sale', sale); stickyPrice.innerHTML = (sale ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price); }
      $$('[data-klarna]', root).forEach((k) => { k.textContent = '3 × ' + money(Math.floor(v.price / 3)); });
      const radio = $(`input[type="radio"][value="${CSS.escape(v.option1)}"]`, form);
      const sub = btn && $('[data-add-sub]', btn);
      if (sub) { sub.hidden = !v.available; sub.textContent = money(v.price); }
      if (stickySize && radio) stickySize.textContent = radio.dataset.label.replace(/\s*cm$/, '');
      if (useEl && radio) { const use = radio.dataset.use; useEl.querySelector('[data-use-text]').innerHTML = use ? `<strong>${radio.dataset.label}</strong> — ${use}` : ''; useEl.hidden = !use; }
      if (radio) setScene(parseInt(radio.dataset.w, 10), parseInt(radio.dataset.h, 10));
      $$('[data-scene-size]', root).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.sceneSize === v.option1)));
      document.dispatchEvent(new CustomEvent('lazuli:taille', { detail: v.option1 }));
      const gpos = v.featured_image && v.featured_image.position;
      const gtrack = $('[data-gallery-track]', root);
      if (gpos && gtrack) gtrack.scrollTo({ left: (gpos - 1) * gtrack.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      if (btn) btn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? btn.dataset.textAdd : btn.dataset.textSoldout;
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    };
    form?.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"], select')) update(); });
    /* Les boutons du plan pilotent la vraie taille du produit : prix et panier suivent. */
    $$('[data-scene-size]', root).forEach((b) => b.addEventListener('click', () => {
      const r = $(`input[type="radio"][value="${CSS.escape(b.dataset.sceneSize)}"]`, form);
      if (r && !r.disabled) { r.checked = true; update(); }
    }));

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.classList.add('is-loading');
      try {
        await cart.add([{ id: parseInt(idInput.value, 10), quantity: 1 }]);
        if (!cart.giftPending) cart.open();
      } catch (err) { toast(err.message); }
      finally { btn.classList.remove('is-loading'); }
    });

    $('[data-scene-toggle]', root)?.addEventListener('click', (e) => {
      const box = $('[data-scene-box]', root);
      const on = !box.classList.contains('is-open');
      if (on) $$('[data-scene-img][data-src]', box).forEach((im) => {
        im.setAttribute('href', im.dataset.src); im.removeAttribute('data-src');
      });
      box.classList.toggle('is-open', on);
      e.currentTarget.setAttribute('aria-expanded', String(on));
      e.currentTarget.textContent = on ? e.currentTarget.dataset.textClose : e.currentTarget.dataset.textOpen;
      if (on) { const v = findVariant(); const radio = v && $(`input[type="radio"][value="${CSS.escape(v.option1)}"]`, form); if (radio) setScene(parseInt(radio.dataset.w, 10), parseInt(radio.dataset.h, 10)); }
    });

    /* Barre d'achat en haut de l'écran : visible dès que le bouton principal est passé
       au-dessus de l'écran, cachée quand on remonte. Posée sur <body> pour qu'aucun parent
       animé ne la décale. */
    const sticky = $('[data-sticky-buy]', root);
    if (sticky && btn && 'IntersectionObserver' in window) {
      document.body.appendChild(sticky);
      let barreVue = false;
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.inert = !show;
        if (show && !barreVue) { barreVue = true; suivi('vu', { zone: 'barre-achat' }); }
      }, { threshold: 0 }).observe(btn);
      $('[data-sticky-submit]', sticky)?.addEventListener('click', () => { suivi('clic-barre-achat'); form.requestSubmit(); });
    }

    /* Galerie : carrousel, vignettes, fleches. Pas de defilement automatique :
       il changeait l'image pendant qu'on detaillait le motif. */
    const track = $('[data-gallery-track]', root);
    if (track) {
      const items = $$('.gallery__item', track);
      const dots = $$('[data-gallery-dot]', root);
      const counter = $('[data-gallery-counter]', root);
      let cur = 0;
      const set = (i) => {
        cur = i;
        dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
        if (counter) counter.textContent = `${i + 1} / ${items.length}`;
        /* On fait defiler la bande de vignettes elle-meme : scrollIntoView
           entrainait toute la page vers le haut a chaque changement d'image. */
        const d = dots[i], bande = d && d.parentElement;
        if (d && bande && bande.scrollWidth > bande.clientWidth) {
          const cible = d.offsetLeft - (bande.clientWidth - d.offsetWidth) / 2;
          bande.scrollTo({ left: Math.max(0, cible), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      };
      const go = (i, smooth = true) => {
        const n = (i + items.length) % items.length;
        track.scrollTo({ left: n * track.clientWidth, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      };
      track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) set(i); }, { passive: true });
      dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
      $('[data-gallery-prev]', root)?.addEventListener('click', () => go(cur - 1));
      $('[data-gallery-next]', root)?.addEventListener('click', () => go(cur + 1));
      set(0);

      /* Plein ecran : toucher une image l'ouvre en grand ; toucher a nouveau
         l'affiche a sa taille reelle, on la parcourt du doigt (le pincement marche aussi). */
      const zoom = $('[data-zoom]', root);
      if (zoom && typeof zoom.showModal === 'function') {
        const zimg = $('[data-zoom-img]', zoom);
        const stage = $('[data-zoom-stage]', zoom);
        const hint = $('[data-zoom-hint]', zoom);
        let zi = 0;
        const show = (i) => {
          zi = (i + items.length) % items.length;
          zoom.classList.remove('is-full');
          zimg.src = items[zi].dataset.zoomSrc;
          zimg.alt = $('img', items[zi])?.alt || '';
          if (hint) hint.hidden = false;
        };
        const open = (i) => {
          suivi('zoom-image', { image: i + 1 });
          show(i);
          zoom.showModal();
          document.documentElement.classList.add('is-zoom');
        };
        items.forEach((it, i) => {
          it.addEventListener('click', () => open(i));
          it.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
        });
        zimg.addEventListener('click', (e) => {
          const full = !zoom.classList.contains('is-full');
          const bx = zimg.getBoundingClientRect();
          const rx = (e.clientX - bx.left) / bx.width, ry = (e.clientY - bx.top) / bx.height;
          zoom.classList.toggle('is-full', full);
          if (hint) hint.hidden = true;
          if (full) {
            /* On centre le zoom sur l'endroit touche */
            requestAnimationFrame(() => {
              stage.scrollLeft = rx * zimg.offsetWidth - stage.clientWidth / 2;
              stage.scrollTop = ry * zimg.offsetHeight - stage.clientHeight / 2;
            });
          }
        });
        $('[data-zoom-close]', zoom).addEventListener('click', () => zoom.close());
        $('[data-zoom-prev]', zoom)?.addEventListener('click', () => { show(zi - 1); go(zi, false); });
        $('[data-zoom-next]', zoom)?.addEventListener('click', () => { show(zi + 1); go(zi, false); });
        zoom.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { show(zi - 1); go(zi, false); }
          if (e.key === 'ArrowRight') { show(zi + 1); go(zi, false); }
        });
        zoom.addEventListener('close', () => document.documentElement.classList.remove('is-zoom'));
      }
    }

    update();
  });

  /* ---------- Filtre de taille sur les grilles ---------- */
  $$('[data-size-filter]').forEach((bar) => {
    const grid = document.getElementById(bar.dataset.sizeFilter);
    if (!grid) return;
    const apply = (size) => {
      $$('.pill', bar).forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.size === size)));
      $$('.card[data-prices]', grid).forEach((card) => {
        const prices = JSON.parse(card.dataset.prices);
        const hit = prices[size];
        if (!hit) return;
        const p = $('.card__price', card), s = $('.card__size', card), a = card.matches('a') ? card : $('a', card);
        const sale = !!(hit.compare && hit.compare > hit.price);
        const now = $('[data-card-now]', card), was = $('[data-card-was]', card), badge = $('[data-card-badge]', card);
        if (now) now.textContent = money(hit.price); else if (p) p.textContent = money(hit.price);
        if (p) p.classList.toggle('is-sale', sale);
        if (was) { was.hidden = !sale; if (sale) was.textContent = money(hit.compare); }
        if (badge) badge.hidden = !sale;
        if (s) s.textContent = hit.label;
        if (a) { const u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', hit.id); a.setAttribute('href', u.pathname + u.search); }
      });
    };
    bar.addEventListener('click', (e) => { const p = e.target.closest('.pill'); if (p) apply(p.dataset.size); });
    /* Pas de memoire entre les pages : on revient toujours sur la taille par defaut. */
  });

  /* ---------- Guide des tailles (accueil, page, fiche produit) ---------- */
  $$('[data-size-guide]').forEach((root) => {
    const scene = $('[data-scene]', root);
    const rows = $$('[data-size-pick]', root);
    /* Sur la fiche, le guide et le choix de taille ne font qu'un : une ligne
       choisie ici change la taille achetee, et inversement. */
    const form = root.hasAttribute('data-size-sync') ? $('form[data-product-form]') : null;
    const radioDe = (row) => form && $$('input[type="radio"][name^="options"]', form).find((x) => x.value === row.dataset.title);
    const set = (row) => {
      rows.forEach((r) => r.setAttribute('aria-pressed', String(r === row)));
      placeRug(scene, parseInt(row.dataset.w, 10), parseInt(row.dataset.h, 10), scene && scene.dataset.portrait === 'true');
      const use = $('[data-guide-use]', root);
      if (use) use.textContent = row.dataset.use || '';
    };
    $$('[data-scene-img][data-src]', root).forEach((im) => { im.setAttribute('href', im.dataset.src); im.removeAttribute('data-src'); });
    rows.forEach((r) => r.addEventListener('click', () => {
      set(r);
      const radio = radioDe(r);
      if (radio && !radio.disabled && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    }));
    if (form) document.addEventListener('lazuli:taille', (e) => {
      const r = rows.find((x) => x.dataset.title === e.detail);
      if (r && r.getAttribute('aria-pressed') !== 'true') set(r);
    });
    const coche = form && $('input[type="radio"][name^="options"]:checked', form);
    const start = (coche && rows.find((r) => r.dataset.title === coche.value))
      || rows.find((r) => r.getAttribute('aria-pressed') === 'true') || rows[1] || rows[0];
    if (start) set(start);
  });

  /* ---------- Bandeau cookies ---------- */
  const cookies = $('[data-cookies]');
  if (cookies) {
    const KEYC = 'al-consent';
    const optAnalytics = $('[data-consent-analytics]', cookies);
    const optMarketing = $('[data-consent-marketing]', cookies);
    const show = () => cookies.classList.add('is-visible');
    const hide = () => cookies.classList.remove('is-visible');
    const save = (analytics, marketing) => {
      const apply = () => {
        const api = window.Shopify && window.Shopify.customerPrivacy;
        if (api && api.setTrackingConsent) {
          /* sale_of_data suit le choix « publicité ». À false pour tout le monde (avant le 12/10), il faisait taire
             les pixels classés « vente de données » — celui de Google — même après « Tout accepter ». */
          api.setTrackingConsent({ analytics, marketing, preferences: true, sale_of_data: marketing }, () => {});
        }
      };
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) apply(); });
      }
      try { localStorage.setItem(KEYC, JSON.stringify({ analytics, marketing, v: 2, t: Date.now() })); } catch (e) { /* rien */ }
      hide();
    };
    $('[data-consent-accept]', cookies)?.addEventListener('click', () => save(true, true));
    $('[data-consent-refuse]', cookies)?.addEventListener('click', () => save(false, false));
    $('[data-consent-save]', cookies)?.addEventListener('click', () => save(!!optAnalytics?.checked, !!optMarketing?.checked));
    $('[data-consent-more]', cookies)?.addEventListener('click', (e) => {
      const opts = $('[data-consent-options]', cookies);
      opts.hidden = !opts.hidden;
      $('[data-consent-save]', cookies).hidden = opts.hidden;
      e.currentTarget.hidden = true;
    });
    $$('[data-cookies-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); show(); }));
    let stored = null; try { stored = localStorage.getItem(KEYC); } catch (e) { /* rien */ }
    if (!stored) setTimeout(show, 1200);
    else {
      /* Ceux qui avaient accepté la publicité avant la correction du 12/10 : leur choix est renvoyé une fois, avec le bon réglage. */
      try { const c = JSON.parse(stored); if (c && c.marketing === true && c.v !== 2) save(c.analytics === true, true); } catch (e) { /* rien */ }
    }
  }

  /* ---------- Formulaire de contact : retour visuel ---------- */
  if (location.hash === '#contact-form' || location.hash === '#ContactForm') { $('#contact')?.scrollIntoView({ block: 'start' }); }
})();
